import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { ShowOnMapButton } from 'app/agriculture/components/ContentBox/components/ShowOnMapButton';
import { useEntities } from 'app/agriculture/queries/entities/useEntities';

export function HerdShowOnMapButton({ herdId }: { herdId: string }) {
    const paddocks = useEntities('Paddock');
    const { paddockId } =
        useSnapshot({ snapshotType: 'Herd', parentId: herdId, shelfLife: null }) ?? {};

    if (paddockId == null) return null;

    const paddock = paddocks.get(paddockId);

    if (paddock == null) return null;

    return <ShowOnMapButton position={paddock.pole.coordinates} />;
}
